import React from "react";

function SpecialOrder(){



    return(
        <div>
            <section id="breadcrumb" className="bg-white py-4 border-b">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                        <a href="#" className="hover:text-custom-green">Home</a>
                        <i className="fa-solid fa-chevron-right text-xs"></i>
                        <a href="#" className="hover:text-custom-green">Products</a>
                        <i className="fa-solid fa-chevron-right text-xs"></i>
                        <span className="text-custom-green font-medium">Custom Order</span>
                    </div>
                </div>
            </section>

            <section id="custom-order-hero" className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl font-serif font-bold text-custom-green mb-4">Create Your Custom Basket</h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">Δεχόμαστε παραγγελίες σε χρώμα, πλέξη και διαστάσεις της επιλογής σας.
                        Για τα καλάθια και τα βάζα μπορείτε να διαλέξετε συνδυασμούς δύο ή τριών
                        χρωμάτων και ειδικά μεγέθη ανάλογα με το τι εξυπηρετεί το χώρο σας.
                        Για ειδική παραγγελία παρακαλώ καλέστε στο 6976906868.</p>
                </div>
            </section>

        </div>
    );
}

export default SpecialOrder;